export default {
  LOCALE: "pt-PT",
  IMAGES_HOST: "https://static.filmin.pt",
  FACEBOOK_LINK: "https://www.facebook.com/filmin.pt",
  TWITTER_LINK: "https://twitter.com/FilminPortugal",
  INSTAGRAM_LINK: "https://www.instagram.com/FilminPortugal/",
  LINKEDIN_LINK: "https://www.linkedin.com/company/filmin/mycompany/",
  PINTEREST_LINK: "https://www.pinterest.es/enfilmin/",
};
